<template>
  <div class="system-fail">
    <div class="system-fail__img"></div>
    <div class="system-fail__title">
      系统异常，请重试</div>
    <div class="system-fail__message">
      请检查网络设置或稍后重试</div>
    <div
      class="system-fail__btn"
      @click="reTry"
    >重试</div>
  </div>
</template>

<script>
export default {
  methods: {
    reTry() {
      this.$emit('retry');
    }
  }
};
</script>

<style scoped lang="less">
@import '../styles/fn.less';
.system-fail {
  margin: auto;
  .calc-top(padding-top, 248px);
  text-align: center;
  .system-fail__img {
    margin: auto;
    width: 3.9rem;
    height: 2.61rem;
    .bg-image-auto('https://p0.meituan.net/wxapp/ea40ec875e71d9f1d697a06c82193b0515233.png');
  }
  .system-fail__title {
    margin-top: 0.31rem;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #191919;
    letter-spacing: 1.4px;
    text-align: center;
    line-height: 0.45rem;
    font-weight: 500;
  }
  .system-fail__message {
    font-family: PingFangSC-Regular;
    font-size: 0.30rem;
    color: #999999;
    letter-spacing: 1.5px;
    text-align: center;
    line-height: 0.45rem;
    font-weight: 400;
  }
  .system-fail__btn {
    margin: 0.42rem auto auto;
    width: 1.7rem;
    height: 0.7rem;
    background: #FFC300;
    border-radius: 0.35rem;
    font-family: PingFangSC-Medium;
    font-size: 0.26rem;
    color: #4A1504;
    letter-spacing: 1.14px;
    text-align: center;
    line-height: 0.7rem;
    font-weight: 500;
  }
}
</style>
